import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  DestroyRef,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ValidationService } from '../../services/validation.service';
import { MatIconModule } from '@angular/material/icon';

export interface SearchState {
  value: string;
  isValid: boolean;
}

@Component({
  selector: 'app-pill-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatIconModule],
  templateUrl: './pill-search.component.html',
  styleUrls: ['./pill-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillSearchComponent implements OnInit, OnChanges {
  @Input() placeholder = 'Search';
  @Input() searchText = '';
  @Input() isDisabled = false;
  @Input() customStyles: { [key: string]: string } = {};
  @Output() searchChange = new EventEmitter<SearchState>();

  searchControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [ValidationService.textValidator(0, 100)],
  });

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (this.isDisabled) {
      this.searchControl.disable();
    }

    this.searchControl.setValue(this.searchText);
    this.searchControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(300), distinctUntilChanged())
      .subscribe((value) => {
          this.searchChange.emit({ value, isValid: this.searchControl.valid });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled']) {
      if (this.isDisabled) {
        this.searchControl.disable({ emitEvent: false });
      } else {
        this.searchControl.enable({ emitEvent: false });
      }
    }

    if (changes['searchText']) {
      this.searchControl.setValue(this.searchText, { emitEvent: false });
    }
  }

  clear(): void {
    this.searchControl.setValue('');
  }
}
